<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'Setting'
};
</script>

<style lang="less" scoped>
</style>
